export const translationsMaps = {
	costs: {
		low: 'recipeDetails_info_costValueLow',
		medium: 'recipeDetails_info_costValueMedium',
		high: 'recipeDetails_info_costValueHigh'
	},
	difficulty: {
		easy: 'recipeDetails_info_difficultyValueEasy',
		medium: 'recipeDetails_info_difficultyValueMedium',
		hard: 'recipeDetails_info_difficultyValueHard'
	}
}